/**
 * Pearla 品牌 - Book 页面配置
 */
import { commonTexts } from './common'
import type { BookPageConfig } from './types'

/**
 * Pearla 品牌特定主题配置
 */
export const theme = {
  // 引用装饰线颜色 (Pearla 使用紫色调,基于主色 #AB75FB)
  quoteColor: 'rgba(171, 117, 251, 0.3)',
} as const

export const bookConfig: BookPageConfig = {
  theme,
  texts: commonTexts,
}
